import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SPACING, ALIGN, VERTICAL_ALIGN } from './constants';
import generateClassModifiers from '../../helpers/generate-class-modifiers';

const HorizontalStack = ({
  children,
  gap = 'spacing-4-xs',
  rowGap = 'spacing-4-xs',
  breakpoints = null,
  wrap = false,
  align = ALIGN.left,
  verticalAlign = VERTICAL_ALIGN.stretch,
}) => {
  const spaceClass = generateClassModifiers('ws-ui-horizontal-stack', { gap });
  const rowSpaceClass = generateClassModifiers('ws-ui-horizontal-stack', { rowGap });
  const breakpointsSpacesClasses =
    breakpoints &&
    Object.keys(breakpoints).map((key) =>
      generateClassModifiers('ws-ui-horizontal-stack', breakpoints[key], key)
    );

  const classes = classNames(
    'ws-ui-horizontal-stack',
    `ws-ui-horizontal-stack--align-${align}`,
    `ws-ui-horizontal-stack--vertical-align-${verticalAlign}`,
    spaceClass,
    rowSpaceClass,
    breakpointsSpacesClasses,
    {
      'ws-ui-horizontal-stack--wrap': wrap,
    }
  );
  return <div className={classes}>{children}</div>;
};

HorizontalStack.propTypes = {
  gap: PropTypes.oneOf(SPACING),
  rowGap: PropTypes.oneOf(SPACING),
  breakpoints: PropTypes.shape({
    xs: PropTypes.shape({
      gap: PropTypes.oneOf(SPACING),
    }),
    sm: PropTypes.shape({
      gap: PropTypes.oneOf(SPACING),
    }),
    md: PropTypes.shape({
      gap: PropTypes.oneOf(SPACING),
    }),
    lg: PropTypes.shape({
      gap: PropTypes.oneOf(SPACING),
    }),
    xl: PropTypes.shape({
      gap: PropTypes.oneOf(SPACING),
    }),
    xxl: PropTypes.shape({
      gap: PropTypes.oneOf(SPACING),
    }),
  }),
  children: PropTypes.node.isRequired,
  wrap: PropTypes.bool,
  align: PropTypes.oneOf(Object.values(ALIGN)),
  verticalAlign: PropTypes.oneOf(Object.values(VERTICAL_ALIGN)),
};

export default HorizontalStack;
